export default __webpack_public_path__ + "e9f2ac942e72c4e228b163edf987ce53.svg";